/**
 * @file 统一处理401未授权跳转逻辑
 */

import {getLoginUrl} from '@/api/login';

/**
 * 统一处理401未授权 - 根据环境和参数决定跳转目标
 *
 * 跳转策略:
 * 1. 有 document.referrer → 跳转登录页 (用户从其他页面跳转来的)
 * 2. 开发环境 (localhost / -dev.) → 跳转登录页
 * 3. URL 参数中存在 invitecode → 跳转登录页 (邀请码流程)
 * 4. 以上都不满足 → 跳转产品介绍页 (用户直接访问 URL)
 */
export function handleUnauthorized(): never {
    const hostname = window.location.hostname;
    const isDev = hostname === 'localhost' || hostname.includes('-dev.');

    // 检查 URL 参数中是否存在 invitecode
    const urlParams = new URLSearchParams(window.location.search);
    const invitecode = urlParams.get('invitecode');

    if (document.referrer || isDev || invitecode) {
        window.location.href = getLoginUrl();
    } else {
        window.location.href = 'https://cloud.baidu.com/product/famou.html';
    }

    // 满足 TypeScript 的 never 类型要求
    throw new Error('Redirecting to login');
}
